const Menu = [
  // {
  //   title: "Dashboard",
  //   group: "apps",
  //   icon: "dashboard",
  //   name: "Dashboard"
  // },
  {
    title: "Schools",
    group: "apps",
    icon: "location_city",
    name: "Company"
  },
  {
    title: "Payments",
    group: "apps",
    icon: "monetization_on",
    name: "Payments"
  },
  {
    title: "Modules",
    group: "apps",
    icon: "store",
    name: "Module"
  },
  {
    title: "Servers",
    icon: "computer",
    name: "Servers"
  },
  {
    title: "Releases",
    icon: "new_releases",
    name: "Releases"
  },
  {
    title: "Support",
    icon: "support",
    name: "Support"
  },
  {
    title: "Release Notes",
    icon: "history",
    name: "ReleaseNotes"
  }
];
// reorder menu
Menu.forEach(item => {
  if (item.items) {
    item.items.sort((x, y) => {
      let textA = x.title.toUpperCase();
      let textB = y.title.toUpperCase();
      return textA < textB ? -1 : textA > textB ? 1 : 0;
    });
  }
});

export default Menu;
